<template>
  <q-td :key="tdKey" :props="props">
    <q-input v-model="valueModel" :type="show ? 'text' : 'password'" dense outlined>
      <template #append>
        <q-icon :name="show ? 'visibility_off' : 'visibility'" class="cursor-pointer" @click="show = !show" />
      </template>
    </q-input>
  </q-td>
</template>

<script>
export default {
  props: {
    props: Object,
    value: String,
    tdKey: {
      type: String,
      required: true
    }
  },

  data: () => ({
    show: false
  }),

  computed: {
    valueModel: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('input', newVal)
      }
    }
  }
}
</script>
